<div>
    <div class="breadcrumb-block">
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item">
                    <router-link :to="{ name:'business-dashboard'}">Home</router-link>
                </li>
                <li class="breadcrumb-item active" aria-current="page">Manage Hotel</li>
            </ol>
        </nav>
    </div>
    <div class="manage-package-block">
        <div class="white-box">
            <div class="error-list" v-if="errorsHotel">
                <ul class="error-msg">
                    <li v-for="(error,x) in errorsHotel" :key="x">
                        <div v-for="(err,i) in error" :key="i">
                            <p> {{err}}</p>
                        </div>
                    </li>
                </ul>
            </div>
            <div class="sort-wrapper">
                <div class="row">
                    <div class="col-lg-6" @click.prevent="toggleFilter">
                        <a class="filter-head" role="button" aria-expanded="false" aria-controls="collapseExample">
                            <i class="fas fa-filter"></i> Show Filter
                        </a>
                    </div>
                    <div class="col-lg-6">
                        <div class="clear text-right" @click="clearAllFilter">
                            <a class="filter-head">
                                <i class="fas fa-redo"></i> clear all filters
                            </a>
                        </div>
                    </div>
                </div>
                <div class="collapse filter-body">
                    <span></span>
                    <form id="formFilterHotel" action="#" class="content-block pb-0">
                        <div class="form-modified">
                            <div class="row">
                                <div class="col-lg-4">
                                    <div class="form-group">
                                        <label for="Package title">Hotel Name</label>
                                        <input type="text" class="form-control" placeholder="hotel name" v-model="RequestTitle" @change="CallHotelsList()" @keyup.enter="CallHotelsList()" @keyup.tab="CallHotelsList()" @keyup="CallHotelsList()">
                                    </div>
                                </div>
                                <div class="col-lg-4">
                                    <div class="form-group">
                                        <label for="Package title">Location</label>
                                        <div class="multiselect-input">
                                            <input type="text " class="form-control " placeholder="hotel location " v-model="RequestAddress " @change="CallHotelsList() " @keyup.enter="CallHotelsList() " @keyup.tab="CallHotelsList() " @keyup="CallHotelsList() ">
                                        </div>
                                    </div>
                                </div>
                                <!-- <div class="col-lg-4 ">
                                    <div class="form-group ">
                                        <label for="Package title ">Price range</label>
                                        <div class="multiselect-input " v-if="RequestBasePriceList ">
                                            <multiselect :options='RequestBasePriceList' label="name " :track-by=" 'id' " v-model="RequestBasePrice " placeholder="Choose base pice range.. " @input="CallPackagesList() ">
                                            </multiselect>
                                        </div>
                                    </div>
                                </div> -->
                                <div class="col-lg-4 ">
                                    <div class="form-group ">
                                        <label for="Package title ">City</label>
                                        <div class="multiselect-input " v-if="CityList ">
                                            <multiselect :options='CityList' label="name" :track-by=" 'id' " v-model="RequestCity " placeholder="Choose city.. " @input="CallHotelsList() ">
                                            </multiselect>
                                        </div>
                                    </div>
                                </div>
                                <!-- 
                                <div class="col-lg-4">
                                    <div class="form-group">
                                        <label for="Package title">Operator</label>
                                        <div class="multiselect-input" v-if="TourOperatorList">
                                            <multiselect :options='TourOperatorList' label="company_name" :track-by="'id'" v-model="RequestOperator" placeholder="Choose operator.." @input="CallHotelsList()">
                                            </multiselect>
                                        </div>
                                    </div>
                                </div> -->
                            </div>
                        </div>
                    </form>
                </div>

            </div>
            <hr>
            <div class="table-title ">
                <div class="container-fluid px-0 ">
                    <div class="row align-items-center ">
                        <div class="col-lg-9 ">
                            <h5>Manage Hotel</h5>
                        </div>
                        <div class="col-lg-3 " v-if="permission.hotel_add ">
                            <a href="# " @click.prevent="hotelModal" class="btn add-btn "><i
                                        class="fas fa-plus "></i>Add New Hotel</a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="table-container ">
                <div class="table-responsive ">
                    <table class="table " id="example ">
                        <thead class="table-light-bg ">
                            <tr>
                                <th scope="col ">Image</th>
                                <th scope="col ">Hotel Name
                                </th>
                                <th scope="col ">Contact
                                </th>
                                <th scope="col ">Address
                                </th>
                                <th scope="col ">Bookings
                                </th>
                                <th scope="col ">Pre-bookings
                                </th>
                                <th scope="col ">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(hotel,index) in HotelLists " :key="index ">
                                <!-- {{trek}} -->
                                <td>
                                    <div class="table-image " @click.prevent="EditHotel(hotel.id) " v-tooltip.top="{ content: 'Edit/View hotel', class: 'tooltip-custom tooltip-other-custom' } ">

                                        <!-- <img v-if="trek.trek_banner_image " :src="trek.trek_banner_image.image_path " alt>
                                        <img v-else src="img/signup-image.jpg " alt> -->

                                        <img src="img/signup-image.jpg " alt>

                                    </div>
                                </td>
                                <td v-if="hotel.title " @click.prevent="EditHotel(hotel.id) ">{{hotel.title}}</td>
                                <td v-else align="center ">-</td>
                                <td v-if="hotel.phone ">{{hotel.phone}} </td>
                                <td v-else align="center ">-</td>
                                <td v-if="hotel.address "><strong class="badge badge-secondary ">{{hotel.address}}</strong></td>
                                <td v-else align="center ">-</td>
                                <td v-else align="center ">-</td>

                                <td>
                                    <!-- <div class="badge "><a @click.prevent="TrekBooking(trek.id) " class="badge badge-success ">{{trek.bookings_count}}</a>
                                    </div> -->
                                    0
                                </td>
                                <td>
                                    <!-- <div class="badge "><a href="javascript:void(0) " class="badge badge-primary ">{{trek.pre_bookings_count}}</a>
                                    </div> -->
                                    <td>
                                        <div class="includes-action justify-content-start ">

                                            <button v-if="permission.hotel_edit " type="button " class="btn blue " @click.prevent="EditHotel(hotel.id) " v-tooltip.top="{ content: 'Edit/View hotel', class: 'tooltip-custom tooltip-other-custom' } ">
                                                <i class="fas fa-pen "></i>
                                            </button>

                                            <!-- <button type="button " v-if="permission.hotel_edit " class="btn orange " @click.prevent="roomManagement(hotel.id) " v-tooltip.top="{ content: 'Manager Room', class:
                                            'tooltip-custom tooltip-other-custom' } ">
                                                <i class="fas fa-plane-departure "></i>
                                            </button> -->
                                        </div>
                                    </td>
                            </tr>

                        </tbody>

                    </table>
                    <div v-if="HotelLists==0 " class="empty-data ">
                        <p>
                            No Hotel List
                        </p>
                    </div>
                    <div class="spinner ">
                        <moon-loader v-if="HotelLists " :loading="IsLoading " :size="50 "></moon-loader>
                    </div>
                </div>
            </div>


            <Pager @onPaging="onPaging " :pager="paging "></Pager>
        </div>
        <!-- Modals Starts Here -->
        <div class="modal-wrap ">
            <!-- <div class="modal fade show " id="createHotel " tabindex="-1 " role="dialog " aria-labelledby="exampleModalLabel " data-keyboard="false " data-backdrop="static " aria-hidden="true "> -->
            <div class="modal fade show" id="createHotel" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" data-keyboard="false" data-backdrop="static" aria-hidden="true">
                <div class="modal-dialog " role="document ">
                    <div class="modal-content ">
                        <div class="modal-header ">
                            <h5 class="modal-title ">Create Hotel</h5>
                            <button type="button " class="close " @click.prevent="hideModalSegment " aria-label="Close ">
                                <span aria-hidden="true ">×</span>
                            </button>
                        </div>
                        <div class="error-list " v-if="errorsModal ">
                            <ul class="error-msg ">
                                <li v-for="(error,x) in errorsModal " :key="x ">
                                    <div v-for="(err,i) in error " :key="i ">
                                        <p> {{err}}</p>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div class="modal-body">
                            <div class="form-modified">
                                <label for="Package title">Property Type</label>
                                <div class="multiselect-input" v-if="PropertyType">
                                    <multiselect placeholder="Choose Propertype Type" :options='PropertyType' v-model="Property" label="name" :track-by="'id'" :class="{ 'error-input' : errors['property_type_id'] }"></multiselect>
                                    <validation-error v-if="isError" :isError="isError" :errors="errors" :field="'property_type_id'" />
                                </div>

                            </div>
                        </div>
                        <div class="modal-body ">
                            <div class="form-modified ">
                                <label for="Hotel title ">Hotel Name</label>
                                <input type="text " class="form-control " :class="{ 'error-input' : errors[ 'title'] } " id="inputPassword " placeholder="Enter hotel name " v-model="Title ">
                            </div>
                            <validation-error v-if="isError " :isError="isError " :errors="errors " :field=" 'title' " />
                        </div>
                        <div class="modal-body ">
                            <div class="form-modified ">
                                <label for="Hotel phone ">Contact</label>
                                <input type="text " class="form-control " :class="{ 'error-input' : errors[ 'phone'] } " id="inputPhone " placeholder="Enter Phone " v-model="Phone ">
                            </div>
                            <validation-error v-if="isError " :isError="isError " :errors="errors " :field=" 'phone' " />
                        </div>
                        <div class="modal-body ">
                            <div class="form-modified ">
                                <label for="Hotel address ">Address</label>
                                <input type="text " class="form-control " :class="{ 'error-input' : errors[ 'address'] } " id="inputAddress " placeholder="Enter address " v-model="Address ">
                            </div>
                            <validation-error v-if="isError " :isError="isError " :errors="errors " :field=" 'address' " />
                        </div>
                        <div class="modal-footer ">
                            <button v-if="permission.hotel_add " type="button " :disabled="ButtonStatus " class="btn default-btn " @click.prevent="CreateHotel() ">Save
                                <spinner v-if="PostLoading " :loading="PostLoading "></spinner>
                            </button>
                            <button type="button " class="btn default-btn cancel " aria-label="Close " @click.prevent="hideModalSegment ">Cancel
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-wrap ">
        <div class="modal fade show " id="delete " tabindex="-1 " role="dialog " aria-labelledby="exampleModalLabel ">
            <div class="modal-dialog modal-dialog-centered " role="document ">
                <div class="modal-content ">
                    <div class="modal-header ">
                        <h5 class="modal-title ">Delete Departure</h5>
                        <button type="button " class="close " data-dismiss="modal " aria-label="Close ">
                            <span aria-hidden="true ">×</span>
                        </button>
                    </div>
                    <div class="modal-body ">
                        <p>Are you sure you want to delete this ?</p>
                    </div>
                    <div class="modal-footer ">
                        <button type="button " class="btn default-btn " @click.prevent="deleteHotel() ">Ok</button>
                        <button type="button " class="btn default-btn cancel " aria-label="Close " @click.prevent="canceldeletePackage() ">Cancel</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</div>